export const tasksStatus = (state) => state.tasksStatus;
export const tasksOverview = (state) => state.tasksOverview;
export const tasksList = (state) => state.tasksList;

export const taskForTeam = (state) => state.taskForTeam;
